import Vue from 'vue'
import Mailcheck from 'mailcheck'

const rules = {
  fbUsername: {
    getMessage() {
      return 'This is a reserved username'
    },
    validate(value) {
      // todo: add 'admin' and 'guest' and some other stuff
      return !value.startsWith('fb-')
    },
  },
  fbUsernameUnique: {
    getMessage(field, args, data) {
      return data
    },
    validate(value) {
      return new Promise(resolve => {
        const formData = new window.FormData()
        formData.append('username', value)

        Vue.http.post(`/api/v1/validate/unique-username`, formData).then(
          res => {
            resolve({
              valid: res.body.status === 'success',
              data: res.body.message,
            })
          },
          () => {
            resolve({
              valid: false,
            })
          },
        )
      })
    },
  },
  fbEmailUnique: {
    getMessage(field, args, data) {
      return data
    },
    validate(value, args) {
      return new Promise(resolve => {
        const formData = new window.FormData()
        formData.append('email', value)

        // tells API to force check against is_blender emails
        if (args[0] === 'force') {
          formData.append('force', 1)
        }

        Vue.http.post(`/api/v1/validate/unique-email`, formData).then(
          res => {
            resolve({
              valid: res.body.status === 'success',
              data: res.body.message,
            })
          },
          () => {
            resolve({
              valid: false,
            })
          },
        )
      })
    },
  },
  notSameAsField: {
    getMessage(field, args) {
      return 'Cannot be the same as ' + args
    },
    validate(value, args) {
      return !(value === document.querySelector("input[name='" + args + "']").value)
    },
  },
  // mailcheck library to find typos in emails like gamil.com
  fbMailcheck: {
    getMessage(field, args, data) {
      return data
    },
    validate(value) {
      return new Promise(resolve => {
        resolve(
          Mailcheck.run({
            email: value,
            suggested(suggestion) {
              return {
                valid: false,
                data: 'Did you mean: ' + suggestion.full + '?',
              }
            },
            empty() {
              return {
                valid: true,
              }
            },
          }),
        )
      })
    },
  },

  // todo: get this to work with a file of common passwords, not sure where that should live
  /*
    'fbCommonPassword': {
    getMessage(field, args, data) {
        return 'This is a common password and not allowed'
    },
    validate(value, args) {
        return  (common_passwords.indexOf(value) === -1)
    }
  }
     */
}

// export an 'install' function.
export default Validator => {
  // for every rule we defined above.
  Object.keys(rules).forEach(rule => {
    // add the rule.
    Validator.extend(rule, rules[rule])
  })
}
